import React from "react";
import auth from '../service/Auth'

import { NavLink } from "react-router-dom";
import Button from '@mui/material/Button';


const LogoutButton = (props) => {

    const logout = () => {
        auth.user.keycloak.logout().then((response) => {}).catch(e=>{})
    }
    
    return(
        <React.Fragment>
            {
                (auth.tokenExpired()) ? 
                    <Button>
                        <NavLink exact to={{ pathname: "/login/", state: { from: window.location.href }}}>
                            LOGIN 
                        </NavLink>
                    </Button>
                :  
                    <Button variant={"primary"} onClick={logout}>
                        <NavLink  exact to={"/#"}>
                            LOGOUT 
                        </NavLink>
                    </Button>
            }
            {props.children}
        </React.Fragment>  
    );

}

export default LogoutButton;